import React from 'react';
import { LoadingFrame } from '../../../../ui/LoadingGuard';
import { useLocationScope } from '../../../AppLocation';
import { EnableIfHasFeature, HideIfHasFeature } from '../../../common/FeatureElements';
import { ManageFrame } from '../ManageFrame';
import ManageSingleSignOnForm from './ManageSingleSignOnForm';
import { useSingleSignOnQuery } from './SingleSignOnHooks';
import { SingleSignOnPremiumCallout } from './SingleSignOnPremiumCallout';

export const ManageSingleSignOnView = React.memo(() => {
    useLocationScope('sso', 'overview');
    const { isLoading, data } = useSingleSignOnQuery();

    return <ManageFrame title="Single Sign-On (SAML)">
        <HideIfHasFeature name="singleSignOn">
            <SingleSignOnPremiumCallout />
        </HideIfHasFeature>
        {isLoading && <LoadingFrame />}
        {!isLoading && <>
            <EnableIfHasFeature name="singleSignOn">
                <ManageSingleSignOnForm data={data} />
            </EnableIfHasFeature>
        </>}
    </ManageFrame>;
});
